import React from 'react';

const IconFacebookOutline: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      d="M17.0444712,1.65144231 L17.0444712,4.98317308 L15.063101,4.98317308 C14.3395397,4.98317308 13.8515638,5.13461387 13.5991587,5.4375 C13.3467535,5.74038613 13.2205529,6.19470851 13.2205529,6.80048077 L13.2205529,9.18569712 L16.9182692,9.18569712 L16.4260817,12.921274 L13.2205529,12.921274 L13.2205529,22.5 L9.35877404,22.5 L9.35877404,12.921274 L6.140625,12.921274 L6.140625,9.18569712 L9.35877404,9.18569712 L9.35877404,6.43449519 C9.35877404,4.86958352 9.79626966,3.65595383 10.671274,2.79356971 C11.5462784,1.93118559 12.7115312,1.5 14.1670673,1.5 C15.4038523,1.5 16.3629774,1.55048026 17.0444712,1.65144231 L17.0444712,1.65144231 Z"
    />
  </svg>
);

export default IconFacebookOutline;
